import React from 'react'
import PropTypes from 'prop-types'
import theme from 'styles/theme'
import IconWrapper from './IconWrapper'

const BookingUrlIcon = ({ color, width, height, display }) => (
  <IconWrapper width={width} height={height} display={display}>
    <svg width={width} height={height} xmlns="http://www.w3.org/2000/svg">
      <g fill="none" fillRule="evenodd">
        <path
          fill="none"
          d="M0 0h32v32H0z"
          fillOpacity="0"
          fillRule="nonzero"
        />
        <rect stroke="#455255" x="3.5" y="7.5" width="25" height="18" rx="2" />
        <rect stroke="#455255" x="3.5" y="7.5" width="25" height="18" rx="2" />
        <path
          fill="#455255"
          fillRule="nonzero"
          d="M7 6h1v3H7zM24 6h1v3h-1zM18.333 6h1v3h-1zM12.667 6h1v3h-1z"
        />
        <path stroke={color} d="M3.5 12.5h25" />
      </g>
    </svg>
  </IconWrapper>
)

BookingUrlIcon.propTypes = {
  color: PropTypes.string,
  width: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.arrayOf(PropTypes.number),
  ]),
  height: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.arrayOf(PropTypes.number),
  ]),
  display: PropTypes.string,
}

BookingUrlIcon.defaultProps = {
  color: theme.colors.coaldark,
  width: '32px',
  height: '32px',
  display: 'block',
}

export default BookingUrlIcon
